/**
 * Supabase Client (Browser-side)
 *
 * Use this client for browser-side operations in Client Components.
 * This client uses the anon key and respects RLS policies.
 *
 * @example
 * ```ts
 * import { createClient } from '@/lib/supabase/client';
 *
 * const supabase = createClient();
 * const { data } = await supabase.from('products').select('*');
 * ```
 */

import { createBrowserClient } from '@supabase/ssr';
import type { Database } from '@/types/database';
import { AUTH_COOKIE_NAME } from './cookie-name';

export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { cookieOptions: { name: AUTH_COOKIE_NAME } }
  );
}
